const BOLD_REGEX = /\*\*([\s\S]+?)\*\*|<strong>([\s\S]*?)<\/strong>|\*([^*\n]+)\*/gi;
const LINE_BREAK_REGEX = /<br\s*\/?\s*>/gi;
const HTML_TAG_REGEX = /<[^>]*>/g;

function stripTags (text) {
    return text.replace(HTML_TAG_REGEX, '');
}

function parseBoldSegments (text) {
    const originalText = (text || '')
        .toString()
        .replace(LINE_BREAK_REGEX, '\n');

    if (!originalText) {
        return [{ text: '', isBold: false }];
    }

    const segments = [];
    const boldRegex = new RegExp(BOLD_REGEX.source, BOLD_REGEX.flags);
    let cursor = 0;
    let match = boldRegex.exec(originalText);

    while (match) {
        if (match.index > cursor) {
            segments.push({
                text: stripTags(originalText.slice(cursor, match.index)),
                isBold: false,
            });
        }

        segments.push({
            text: stripTags(match[1] || match[2] || match[3] || ''),
            isBold: true,
        });

        cursor = match.index + match[0].length;
        match = boldRegex.exec(originalText);
    }

    if (cursor < originalText.length) {
        segments.push({
            text: stripTags(originalText.slice(cursor)),
            isBold: false,
        });
    }

    return segments.length > 0 ? segments : [{ text: stripTags(originalText), isBold: false }];
}

function segmentsToPlainText (segments) {
    return segments.map(segment => segment.text).join('');
}

function toPlainText (text) {
    return segmentsToPlainText(parseBoldSegments(text));
}

module.exports = { parseBoldSegments, segmentsToPlainText, toPlainText };
